$(function () {
    $('.news-hero__filters .filter-box').each(function() {

        var _this = $(this);

        var toggle = _this.find('.filter-box__toggle');

        toggle.on('click', function() {
            _this.toggleClass('open');
        })

    })

})